module.exports = __webpack_public_path__ + "4c009efb08d7ecd9d61207f2aa4b378f.MP3";